var _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NicaraguaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M24,4C15.296,4,7.911,9.571,5.162,17.333h37.675C40.089,9.571,32.704,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.838,30.667C43.577,28.579,44,26.341,44,24c0-2.341-0.423-4.579-1.162-6.667H5.162 C4.423,19.421,4,21.659,4,24c0,2.341,0.423,4.579,1.162,6.667H42.838z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M23.999,44h0.002c8.704,0,16.088-5.571,18.836-13.333H5.162C7.911,38.429,15.295,43.999,23.999,44z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "27.333,24.81 20.461,25.042 23.965,18.998"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.958,22.474 23.628,19.515 23.848,19.222"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.387,19.984 23.86,22.446 23.257,20.212"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.135,20.473 23.762,22.462 23.004,20.685"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "22.898,20.864 23.689,22.536 22.792,21.052"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "22.694,21.215 23.673,22.658 22.629,21.362"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "22.54,21.508 23.567,22.658 22.466,21.614"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "22.417,21.753 22.328,21.916 23.567,22.78"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "22.238,22.022 23.501,22.821 22.165,22.128"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.477,22.862 21.993,22.389 22.124,22.258"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.444,22.943 21.847,22.658 21.928,22.495"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.387,23.016 21.749,22.78 21.676,22.927"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.371,23.114 21.504,23.245 21.594,23.098"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.363,23.196 21.227,23.709 21.35,23.473"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.387,23.277 21.007,24.158 21.121,23.921"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.444,23.334 20.51,24.94 20.779,24.533"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.501,23.424 21.651,24.785 21.488,24.655"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.55,23.465 22.002,24.785 22.189,24.785"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.624,23.506 22.336,24.932 22.621,24.851"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.689,23.554 22.882,24.769 23.037,24.753"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.754,23.62 23.159,24.802 23.347,24.72"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.819,23.701 23.42,24.859 23.607,24.842"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.925,23.734 23.787,24.785 23.917,24.777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23.982,22.474 24.313,19.515 24.092,19.222"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.553,19.984 24.08,22.446 24.683,20.212"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.806,20.473 24.178,22.462 24.936,20.685"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.042,20.864 24.251,22.536 25.148,21.052"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.246,21.215 24.268,22.658 25.311,21.362"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.401,21.508 24.374,22.658 25.474,21.614"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.523,21.753 25.613,21.916 24.374,22.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.702,22.022 24.439,22.821 25.776,22.128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.463,22.862 25.947,22.389 25.816,22.258"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.496,22.943 26.094,22.658 26.012,22.495"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.553,23.016 26.191,22.78 26.265,22.927"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.569,23.114 26.436,23.245 26.346,23.098"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.577,23.196 26.713,23.709 26.591,23.473"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.553,23.277 26.933,24.158 26.819,23.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.496,23.334 27.43,24.94 27.161,24.533"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.439,23.424 26.289,24.785 26.452,24.655"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.39,23.465 25.939,24.785 25.751,24.785"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.317,23.506 25.605,24.932 25.319,24.851"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.251,23.554 25.058,24.769 24.904,24.753"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.186,23.62 24.781,24.802 24.594,24.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.121,23.701 24.52,24.859 24.333,24.842"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.015,23.734 24.154,24.785 24.023,24.777"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24.105,23.66c0,0,0.033-0.245,0.253-0.245c0.073-0.391-0.204-0.774-0.375-0.758 c-0.171,0.016-0.505,0.416-0.269,0.334c-0.114,0.245-0.073,0.269-0.073,0.269s0.236,0.106,0.269,0.187 c0.033,0.082,0.024,0.212,0.024,0.212H24.105z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M21.447,24.761c0-0.011-0.003-0.021-0.003-0.032c0-1.393,1.134-2.526,2.527-2.526 c1.393,0,2.527,1.133,2.527,2.526c0,0.011-0.003,0.021-0.003,0.032h0.131c0-0.011,0.003-0.021,0.003-0.032 c0-1.464-1.192-2.657-2.658-2.657s-2.658,1.192-2.658,2.657c0,0.011,0.003,0.021,0.003,0.032H21.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76ff03",
    d: "M21.313,24.761c0-0.011-0.003-0.021-0.003-0.032c0-1.467,1.193-2.66,2.66-2.66 c1.467,0,2.66,1.193,2.66,2.66c0,0.011-0.003,0.021-0.003,0.032h0.131c0-0.011,0.003-0.021,0.003-0.032 c0-1.539-1.253-2.791-2.791-2.791s-2.791,1.253-2.791,2.791c0,0.011,0.003,0.021,0.003,0.032H21.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M21.178,24.761c0-0.011-0.003-0.021-0.003-0.032c0-1.542,1.254-2.795,2.795-2.795 s2.795,1.254,2.795,2.795c0,0.011-0.003,0.021-0.003,0.032h0.131c0-0.011,0.003-0.021,0.003-0.032 c0-1.613-1.313-2.926-2.926-2.926s-2.926,1.313-2.926,2.926c0,0.011,0.003,0.021,0.003,0.032H21.178z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5c6bc0",
    points: "20.714,24.614 27.227,24.614 28.384,26.628 19.537,26.667"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M24,29.975c-2.215,0-4.237-1.217-5.279-3.174l0.266-0.141c0.989,1.859,2.91,3.014,5.014,3.014 c2.104,0,4.025-1.155,5.014-3.015l0.266,0.141C28.238,28.758,26.216,29.975,24,29.975z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M29.975,24h-0.301c0-3.129-2.545-5.674-5.674-5.674S18.326,20.871,18.326,24h-0.301 c0-3.294,2.681-5.975,5.975-5.975S29.975,20.706,29.975,24z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M28.479,26.717H19.45l0.044-0.075l4.471-7.744l0.043,0.074L28.479,26.717z M19.624,26.617h8.682 l-4.341-7.521L19.624,26.617z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#98c91f",
    d: "M19.899,26.032c0.187,0.016,0.505-0.122,0.807-0.122s0.514,0.114,0.815,0.114 c0.302,0,0.636-0.114,0.848-0.122c0.212-0.008,0.522,0.09,0.717,0.082c0.196-0.008,0.717-0.147,0.921-0.147 s0.505,0.073,0.807,0.057c0.302-0.016,0.522-0.122,0.815-0.114c0.293,0.008,0.53,0.008,0.823,0.049c0,0,0.791-0.147,0.97-0.057 s0.473,0.008,0.473,0.008s-0.098-0.139-0.22-0.367c-1.117-0.31-1.402-1.451-1.402-1.451l-0.318-0.016c0,0-0.187,0.546-0.408,0.75 c-0.22-0.179-0.375-0.783-0.375-0.783h-0.277c0,0-0.114,0.497-0.408,0.766c-0.196-0.179-0.334-0.758-0.334-0.758l-0.359-0.008 c0,0-0.106,0.465-0.293,0.799c-0.196-0.13-0.383-0.799-0.383-0.799l-0.293-0.016c0,0-0.204,0.546-0.416,0.84 c-0.212-0.171-0.399-0.758-0.399-0.758s-0.228-0.065-0.245,0.041c-0.285,1.1-1.598,1.565-1.598,1.565L19.899,26.032z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eeff41",
    d: "M23.192,25.666c0,0-0.97-0.97-1.158-1.655c-0.114-0.008-0.196-0.057-0.196-0.057 s-0.016,0.986,0.245,1.312C22.344,25.592,23.192,25.666,23.192,25.666z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eeff41",
    d: "M22.947,23.889c0,0-0.326,1.696,1.263,1.72c-0.204-0.114-0.302-0.228-0.302-0.228l0.351-0.041 c0,0-0.799-0.334-1.158-1.459C23.021,23.889,22.947,23.889,22.947,23.889z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eeff41",
    d: "M24.015,23.954c0,0-0.122,1.492,1.312,1.492c-0.057-0.082-0.351-0.318-0.351-0.318 s0.179-0.758,0.09-1.215c-0.106-0.008-0.179,0.049-0.179,0.049s-0.212,0.636-0.391,0.75c-0.139-0.179-0.318-0.758-0.318-0.758 H24.015z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eeff41",
    d: "M26.151,23.921c0,0,0.065,0.856-0.179,1.206c-0.13-0.09-0.424-0.432-0.424-0.432 s0.399-0.408,0.408-0.75C26.077,23.962,26.151,23.921,26.151,23.921z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NicaraguaCircular);
export default __webpack_public_path__ + "static/media/icons8-nicaragua-circular.69bbc59cd4343f18c1684d3db4999b08.svg";
export { ForwardRef as ReactComponent };